/* Photos stay on the applicant's device while being optimised. PDFs/unsupported decoders
   pass through unchanged. Keep a 3200px long edge and high JPEG quality for small print. */
window.luxOptimiseDocument = async function (file) {
  if (!/image\/(jpeg|png|webp|avif|heic|heif)/i.test(file.type) || file.size < 1200000) return file;
  var bitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    if (!bitmap.width || !bitmap.height || bitmap.width * bitmap.height > 60000000) return file;
    var scale = Math.min(1, 3200 / Math.max(bitmap.width, bitmap.height));
    var canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale); canvas.height = Math.round(bitmap.height * scale);
    var context = canvas.getContext('2d');
    context.fillStyle = '#fff'; context.fillRect(0, 0, canvas.width, canvas.height);
    context.imageSmoothingQuality = 'high'; context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/jpeg', 0.94); });
    canvas.width = canvas.height = 0;
    if (!blob || blob.size >= file.size * 0.9) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch (_) { return file; }
  finally { if (bitmap) bitmap.close(); }
};
